/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUser } from '../models/SimpleUser';
import { TranscoderData } from '../models/TranscoderData';
import { URI } from '../models/URI';
import { HttpFile } from '../http/http';

export class HorseVideo {
    'id': number;
    'dtCreated': Date;
    'dtModified': Date;
    'name'?: string;
    'horse': string;
    'video'?: URI;
    'uploadSession': string;
    'transcoded'?: TranscoderData;
    'thumbnail'?: URI;
    'user'?: SimpleUser;
    'isSaleVideo'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtModified",
            "baseName": "dtModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "string",
            "format": ""
        },
        {
            "name": "video",
            "baseName": "video",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "uploadSession",
            "baseName": "uploadSession",
            "type": "string",
            "format": ""
        },
        {
            "name": "transcoded",
            "baseName": "transcoded",
            "type": "TranscoderData",
            "format": ""
        },
        {
            "name": "thumbnail",
            "baseName": "thumbnail",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "isSaleVideo",
            "baseName": "isSaleVideo",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseVideo.attributeTypeMap;
    }

    public constructor() {
    }
}

